<template>
    <div>
        <v-card class="rounded-lg" color="#41916b" elevation="0">
            <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
                    <v-tabs-slider color="#b1e3cc"></v-tabs-slider>

                    <v-tab>{{ $t('titles.attachments') }} - Paciente {{ resource.name }}</v-tab>

                    <v-tab-item>
                        <v-card-text>
                            <v-form @submit.prevent="createAttachments" ref="form">
                                <v-container>
                                    <br>
                                    <v-row dense>
                                        <v-col class="d-flex" cols="12" sm="12" md="2">
                                            <v-autocomplete
                                                :rules="formRules"
                                                :items="attachmentsTypes"
                                                color="#256936" 
                                                class="rounded-lg"
                                                v-model="anexosForm.attachments_type_id"
                                                item-value="id"
                                                item-text="name"  
                                                dense 
                                                outlined>
                                                <template v-slot:label>
                                                    {{ $t('inputs.attachments.kind_of_attachment') }} <span style="color: red;">*</span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="d-flex" cols="12" md="4" sm="4">
                                            <v-text-field
                                            color="#086318" 
                                            class="rounded-lg"
                                            :rules="formRules" 
                                            outlined
                                            v-model="anexosForm.attachment_name" 
                                            dense>
                                            <template v-slot:label>
                                                {{ $t('inputs.attachments.description') }} <span style="color: red;">*</span>
                                            </template>
                                        </v-text-field>
                                        </v-col>
                                        <v-col class="d-flex" cols="12" sm="7" md="5">
                                            <v-file-input
                                                v-model="anexosForm.attachment"
                                                :rules="formRules"
                                                class="rounded-lg"
                                                color="black"
                                                append-icon="mdi-file"
                                                prepend-icon=""
                                                show-size
                                                outlined
                                                dense>
                                                <template v-slot:label>
                                                    {{ $t('inputs.attachments.attachment') }} <span style="color: red;">*</span>
                                                </template>
                                            </v-file-input>
                                        </v-col>
                                        <v-col class="d-flex" cols="12" sm="1">
                                            <v-tooltip right color="green">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mx-1" small fab dark color="#41916b" v-bind="attrs" v-on="on" @click="addAttachment()">
                                                        <v-icon dark> mdi-plus </v-icon>
                                                    </v-btn>
                                                </template>
                                            <span>{{ $t('inputs.attachments.input_attachment') }}</span>
                                            </v-tooltip>
                                            <p class="space"></p>
                                        </v-col>
                                    </v-row> 
                                    
                                    <template>
                                        <v-data-table
                                            :headers="headers"
                                            :items="arquivos"
                                            :items-per-page="5"
                                            :footer-props="{'items-per-page-text': 'Arquivos por Página',}"
                                            :loading="loading"
                                            class="elevation-1">
                                            <template v-slot:[`item.actions`]="{ item }">
                                                <v-tooltip left color="#41916b">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon 
                                                            size="20"
                                                            class="icon"
                                                            color="primary" 
                                                            align-item="center"
                                                            v-on="on"
                                                            v-bind="attrs"
                                                            @click="downloadAttachment(item)">
                                                            mdi-download
                                                        </v-icon>
                                                    </template>
                                                    <span style="color:white">{{ $t('buttons.download') }}</span>
                                                </v-tooltip>
                                                <v-tooltip right color="#41916b">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon 
                                                            size="20"
                                                            class="icon"
                                                            color="red" 
                                                            align-item="center"
                                                            v-on="on"
                                                            v-bind="attrs"
                                                            @click="deleteAttachment(item)">
                                                            mdi-trash-can-outline
                                                        </v-icon>
                                                    </template>
                                                    <span style="color:white">{{ $t('buttons.delete') }}</span>
                                                </v-tooltip> 
                                            </template>
                                        </v-data-table>
                                    </template> 
                                </v-container>

                                <v-row class="redirect-actions" dense>
                                    <v-col class="redirect-action-col" cols="12" sm="auto">
                                        <BackToGridBtn />
                                    </v-col> 
                                    <v-spacer /> 
                                    <v-col class="redirect-action-col" cols="12" sm="auto">
                                        <v-btn
                                        class="rounded-lg redirect-action-btn"
                                        block
                                        dark
                                        color="#41916b"
                                        @click="redirect()">
                                            {{$t('buttons.continue')}}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
  
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import fileDownload from "js-file-download";
import currentUser from "@/utils/currentUser";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
    data() {
        return {
            tab:0,
            dialog: false,
            displayError: {
                display: false,
                message: [],
            },
            anexosForm: {
                donor_id: localStorage.getItem('donorId'), 
            },
            headers: [
            {
                text: "Tipo de Anexo",
                align: "center",
                value: "type_of_attachments.name",
            },
            {
                text: "Descrição do Anexo",
                align: "center",
                value: "attachment_name",
            },
            { 
                text: "Ações", 
                value: "actions", 
                align: "center",
                sortable: false 
            },
            ],
            dialogDonor:false,
            donor_id: "",
            loading: false,
            options: {},
            donor:[],
            data:[],
            arquivos: [],
            status_serology: [], 
            selected:"",
            message: "",
            snackbar: false,
            snackbar_error: false,
            messageError: "",
            unity: "",
            donorID: "",
            donorName: "",
            is_donorName: "",
            is_donorSex: "",
            openModal: false,
            donorButton: true,
            formRules: [
                (v) => !!v || this.$t('messages.required_field'),
            ],
            attachmentsTypes: [],
        };
    }, 
    
    async created() {
        const attachmentsTypes = await axios.get(`/attachments_type`);
        this.attachmentsTypes = attachmentsTypes.data.data
    },

    components: {
       BackToGridBtn
    },
 
    computed:{
        ...mapGetters({
            resource: "getPatientData",
            donor_id: "getDonorId"
        }),

        currentUser(){
            return currentUser.getUserData()
        },
    },

    mounted(){
        this.loadTable()
    },
 
    methods: {
        ...mapActions([
            "changeDonorId",
            "changePCRDeathData",
            "changeCaptationData",
            "changeSnackBarData",
            "changePatientData"
        ]),
        
        addAttachment(){
            if (this.$refs.form.validate()) { 
                this.anexosForm.donor_id = this.resource.id ? this.resource.id : this.donor_id
                let anexosData = new FormData();
                    anexosData.append("donor_id", this.anexosForm.donor_id)
                    anexosData.append("attachment_name", this.anexosForm.attachment_name)
                    anexosData.append("attachment", this.anexosForm.attachment)
                    anexosData.append("attachments_type_id", this.anexosForm.attachments_type_id)
                    anexosData.append("user_id", this.currentUser.id)
                    axios
                    .post(`/attachments/create`, anexosData)
                    .then((response) => { 
                        this.anexosForm.attachment_name = "";
                        this.anexosForm.attachment = null; 
                        this.$refs.form.resetValidation();
 
                        this.changeSnackBarData({
                            status: true,
                            type: 'success', 
                            titleMessage: response.data.message,
                            bodyMessage: '',
                            cardColor: 'success',
                            titleIcon: 'mdi-check-circle',
                        }); 

                        setTimeout(() => {
                            this.closeSnackBar();
                        }, 3000);
                    }).catch((err) => {  
                        this.changeSnackBarData({
                            status: true,
                            type: 'erro', 
                            titleMessage: this.$t('messages.something_went_wrong'),
                            bodyMessage: err.details,
                            cardColor: 'red',
                            titleIcon: 'mdi-close-circle',
                        });

                        setTimeout(() => {
                            this.closeSnackBar();
                        }, 3000);
                    }).finally(() => {
                    this.loadTable();
                });
            }
        },

        loadTable(){
            this.loading = true
            let id = this.resource.id
            axios.get(`/attachments/byDonor/${id}`).then((response) => { 
                this.arquivos = response.data; 
            });
            this.loading = false
        },

        deleteAttachment(item){
            this.loading = true;
            const attachmentId = item.id
            axios.delete(`/attachments/${attachmentId}`).then((response) => {
                this.loading = false
                this.changeSnackBarData({
                    status: true,
                    type: 'success', 
                    titleMessage: response.data.message,
                    bodyMessage: '',
                    cardColor: 'success',
                    titleIcon: 'mdi-check-circle',
                }); 

                setTimeout(() => {
                    this.loadTable();
                    this.closeSnackBar();
                }, 3000);

            }).catch((err) => {
                this.loading = false
                const msg = err.details.attachment.join("\n");

                this.changeSnackBarData({
                    status: true,
                    type: "erro",
                    titleMessage: this.$t('messages.something_went_wrong'),
                    bodyMessage: msg,
                    cardColor: "red",
                    titleIcon: "mdi-close-circle",
                }); 
                setTimeout(() => {
                    this.closeSnackBar();
                }, 5000);
            });
        },

        downloadAttachment(item){
            this.loading = true;
            const attachmentId = item.id
            
            axios.get(`/attachments/download/${attachmentId}`, {
                responseType:"blob",
            }).then((response) => {
                let fileType = "";
                if  (response.data.type == "application/pdf") fileType = "pdf";
                if  (response.data.type == "image/png") fileType = "png";
                if  (response.data.type == "image/jpeg") fileType = "jpeg";

                fileDownload(response.data, `doc.${fileType}`);
                this.loading = false
            });
        },

        closeSnackBar(){
            this.changeSnackBarData({
                status: false,
                type: '', 
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        },

        redirect() {
            const status_slug = this.resource.donor_status_slug  == "doacao-aut"
                ? '/cadastrar-captacao'
                : '/pacientes';
            
            if(this.resource) {
                this.changePatientData(this.resource);
            }

            this.$router.push(status_slug);
        }
    },

};
</script>
  
<style scoped> 
p {
    font-size: 16px; 
}

.d-flex {
    padding: 0 12px;
}

.space {
    width: 5px;
} 
 
.redirect-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 8px 0;
}

.redirect-action-col {
  display: flex;
}

@media (max-width: 768px) {
  .redirect-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .redirect-action-col {
    width: 100%; 
  }

  .redirect-action-col:last-child {
    margin-bottom: 0;
  }

  .redirect-actions .v-spacer {
    display: none;
  }
}
</style>
  